<template>
  <div id="body">
    <h1 style="margin-top:0px; padding-top:0px;">Tjuv och polis</h1>
    <p>

    </p>

    <p>Hitta tjuven på så få försök som möjligt</p>

    <div id="kontainer">

    <div id="spelplan">
      <img id="tjuv" src="../assets/Thief.png">
      <canvas id="spelplanCanvas" width="510" height="510">

      </canvas>

    </div>

    <div id="kontrollpanel">
    <br><br><br>Ange koordinater att leta på
    <br>( <input type="text" id="xKoord">  ,  <input type="text" id="yKoord">   )
    <br><br>
     <button type="button" id="letaknapp" v-on:click="leta()">Leta</button>

     <br><br><br><br>Antal försök: <div id="försök">0</div>
     <br><br>
      <button type="button" id="spelaIgen" v-on:click="nyttSpel()">Spela igen</button>
    </div>
  </div>


<div id="licence"> Picture of thief licenced under <a href="https://commons.wikimedia.org/wiki/File:Thief.png">Creative Commons</a> </div>


  </div>
</template>

<script>
export default {
  name: 'Tjuvochpolis',
  props: {
    msg: String,

  },
  methods: {
    slumpaTjuv: function() {
      this.xTjuv = Math.floor(Math.random()*13);
      this.yTjuv = Math.floor(Math.random()*13);
    },
    ritaSpelplan: function(){
      this.gjordaFörsök=0;
      var c = document.getElementById("spelplanCanvas");
      var ctx = c.getContext("2d");
      //koordinataxlar
      ctx.moveTo(15, 490);
      ctx.lineTo(495, 490);
      ctx.stroke();

      ctx.beginPath();
      ctx.moveTo(15, 490);
      ctx.lineTo(15, 10);
      ctx.stroke();

      for(var i = 1; i<=12; i++) {
        ctx.strokeStyle = "grey";
        ctx.beginPath();
        ctx.moveTo(20, i*40-30);
        ctx.lineTo(495, i*40-30);
        ctx.stroke();


        ctx.beginPath();
        ctx.moveTo(i*40+15, 10);
        ctx.lineTo(i*40+15, 495);
        ctx.stroke();


        ctx.strokeStyle = "black";
        ctx.beginPath();
        ctx.moveTo(i*40+15, 485);
        ctx.lineTo(i*40+15, 495);
        ctx.stroke();


        ctx.beginPath();
        ctx.moveTo(10, i*40-30);
        ctx.lineTo(20, i*40-30);
        ctx.stroke();

        ctx.font = "10px Arial";
        ctx.fillText(i,i*40+11,505);
        ctx.fillText(13-i,0, i*40-27);
      }
    },
    leta: function(){
      //document.getElementById("kontrollpanel").style.backgroundColor="red";
      var x = parseInt(document.getElementById("xKoord").value);
      var y = parseInt(document.getElementById("yKoord").value);
      this.gjordaFörsök++;
      document.getElementById("försök").innerHTML = this.gjordaFörsök;
      document.getElementById("xKoord").value = "";
      document.getElementById("yKoord").value = "";

      var stegX = this.xTjuv - x;
      var stegY = this.yTjuv - y;
      var steg = Math.abs(stegX) + Math.abs(stegY);
      if (steg==0) {
          this.sättDitTjuv(x,y);
          this.låsSpel();
          return;
      }

      var c = document.getElementById("spelplanCanvas");
      var ctx = c.getContext("2d");

      ctx.beginPath();
      ctx.arc(x*40+15,480-y*40+11, 10, 0, 2 * Math.PI);
      ctx.fillStyle = "#d0b586";//"white";
      ctx.fill();
      ctx.stroke();

      ctx.fillStyle = "black";
      ctx.font = "10px Arial";
      ctx.fillText(steg,x*40+11,480-y*40+12);





    },
    sättDitTjuv: function(x,y){
      var bild = document.getElementById("tjuv").style;
      bild.left = (x*40)+"px";
      bild.top = (12-y)*40-10 + "px";
      bild.display = "block";

    },
    låsSpel: function() {
      document.getElementById("letaknapp").style.display="none";
      document.getElementById("spelaIgen").style.display="inline";
    },
    nyttSpel: function(){
      location.reload();
    },
  },

  created() {
      document.title = 'Tjuv och polis';
  },
  mounted() {
      this.ritaSpelplan();
      this.slumpaTjuv();
      console.log(this.xTjuv, this.yTjuv);
  },


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
#spelplan{
    background-color: white;
    height: 530px;
    width: 530px;

    display: inline-block;
    position:relative;
}

canvas {

}

#kontrollpanel {
  /*background-color: lightgreen;*/
  height: 530px;
  width: 200px;

  display: inline-block;
  position: absolute;

}

#kontainer {
margin: auto;
}

input {
  width: 20px;
}

#försök{
  display:inline;
}
#body {

  top:0px;
  height: calc(100vh - 50px);
  background: url('https://upload.wikimedia.org/wikipedia/commons/2/2e/Wood_background.jpg') center center fixed;

}

#licence {
  position: absolute;
  bottom:50px;
  left: 10px;
  font-size: 12px;
}

#tjuv{
  height: 50px;
  display:none;
  position: absolute;
}

#spelaIgen{
  display:none;
}

@media only screen and (max-height: 680px) {
  #spelplan {
    scale:85%;
    margin-top: -50px;
  }
}

@media only screen and (max-height: 600px) {
  #spelplan {
    scale:70%;
    margin-top: -70px;
  }
}


</style>
